import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FormsModule } from '@angular/forms';
import { CreateDepartmentMasterComponent } from './components/create-department-master/create-department-master.component';



@NgModule({
  // declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],

  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    CreateDepartmentMasterComponent,
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent
  ]

})
export class PeoplepulseModule { }
